import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path:'/',
        redirect:'/index'
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('../views/IndexView.vue')
    },
    {
        path: '/products',
        name: 'products',
        component: () => import('../views/ProductView.vue'),
    },
    {
        path: '/product/:id',
        name: 'productDetails',
        component: () => import('../views/ProductDetailsView.vue')
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/AboutView.vue')
    },
    {
        path: '/factory',
        name: 'factory',
        component: () => import('../views/FactoryView.vue')
    },
    {
        path: '/contact',
        name: 'contact',
        component: () => import('../views/ContactView.vue')
    }
]

const router = new VueRouter({
    routes
})

export default router
